import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { StateService } from '../services/state.service';

@Injectable({
  providedIn: 'root',
})
export class NoRoadSelectedGuard implements CanActivate {
  constructor(private stateService: StateService, private router: Router) {}

  canActivate(): boolean {
    const selectedRoad = this.stateService.getCurrentSelectedRoad();
    if (selectedRoad) {
      this.router.navigate(['/center-activity']);
      return false;
    }
    return true;
  }
}
